export default __webpack_public_path__ + "static/media/express_black.a3f87e32.png";